import"./Button.css.ts.vanilla.css";var t="_964fy0",r={primary:"_964fy1",secondary:"_964fy2",tertiary:"_964fy3"},y="_964fy4";export{t as buttonBase,r as buttonVariants,y as inlineButton};
